<template>
    <section id="integrations" class="py-20 bg-muted/30">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="text-center max-w-3xl mx-auto mb-16">
                <div class="inline-block px-4 py-2 bg-primary/10 text-primary rounded-full mb-4 uppercase text-sm tracking-wider font-medium">
                    {{ $t('integrations.badge') }}
                </div>
                <h2 class="text-3xl sm:text-4xl mb-4">
                    {{ $t('integrations.title') }}
                </h2>
                <p class="text-lg text-muted-foreground">
                    {{ $t('integrations.subtitle') }}
                </p>
            </div>

            <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto">
                <div class="bg-white border border-border rounded-xl p-6 hover:shadow-lg hover:border-foreground/10 transition-all">
                    <div class="size-12 mb-4 bg-foreground text-white rounded-lg flex items-center justify-center">
                        <BoltIcon class="size-6" />
                    </div>
                    <h3 class="text-xl mb-2">{{ $t('integrations.cards.restApi.title') }}</h3>
                    <p class="text-muted-foreground text-sm">
                        {{ $t('integrations.cards.restApi.description') }}
                    </p>
                </div>

                <div class="bg-white border border-border rounded-xl p-6 hover:shadow-lg hover:border-foreground/10 transition-all">
                    <div class="size-12 mb-4 bg-foreground text-white rounded-lg flex items-center justify-center">
                        <CloudIcon class="size-6" />
                    </div>
                    <h3 class="text-xl mb-2">{{ $t('integrations.cards.saas.title') }}</h3>
                    <p class="text-muted-foreground text-sm">
                        {{ $t('integrations.cards.saas.description') }}
                    </p>
                </div>

                <div class="bg-white border border-border rounded-xl p-6 hover:shadow-lg hover:border-foreground/10 transition-all">
                    <div class="size-12 mb-4 bg-foreground text-white rounded-lg flex items-center justify-center">
                        <ChatBubbleLeftRightIcon class="size-6" />
                    </div>
                    <h3 class="text-xl mb-2">{{ $t('integrations.cards.webhooks.title') }}</h3>
                    <p class="text-muted-foreground text-sm">
                        {{ $t('integrations.cards.webhooks.description') }}
                    </p>
                </div>
            </div>

            <div class="mt-12 bg-white border border-border rounded-xl p-8">
                <div class="text-center max-w-2xl mx-auto">
                    <h3 class="text-2xl mb-3">{{ $t('integrations.custom.title') }}</h3>
                    <p class="text-muted-foreground mb-6">
                        {{ $t('integrations.custom.description') }}
                    </p>
                    <a href="#contact" class="text-accent hover:text-accent/80 transition-colors">
                        {{ $t('integrations.custom.cta') }} →
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { BoltIcon, CloudIcon, ChatBubbleLeftRightIcon } from '@heroicons/vue/24/outline';

export default defineComponent({
    name: 'IntegrationsSection',
    components: {
        BoltIcon,
        CloudIcon,
        ChatBubbleLeftRightIcon
    }
});
</script>
